export default "__VITE_ASSET__Ds9DTmVX__"